import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { cognitoConfig, missingCognitoConfig } from "./config.js";

const oidcConfig = {
  authority: cognitoConfig.authority,
  client_id: cognitoConfig.clientId,
  redirect_uri: cognitoConfig.redirectUri,
  response_type: "code",
  scope: cognitoConfig.scope,
  automaticSilentRenew: true,
  loadUserInfo: false,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, "/cologuard");
  },
};

export default function CologuardAuthProvider({ children }) {
  if (missingCognitoConfig.length > 0) {
    const missingNames = missingCognitoConfig.map(([name]) => name).join(", ");

    return (
      <main style={{ padding: "2rem" }}>
        <h1>Cologuard authentication is not configured</h1>
        <p>Missing environment variables: {missingNames}</p>
      </main>
    );
  }

  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}
